import AddBeneficiaryReimbursement from '../../components/BeneficiaryReimbursement/AddBeneficiaryReimbursement';

export default function AddBeneficiaryReimbursementPage() {
    return (
        <div>
          <AddBeneficiaryReimbursement/>
        </div>
      )
}